// @flow

export const cn = (classes: Object): string => Object.keys(classes).filter((k) => classes[k]).join(' ');